import { ApplicationManagerRegistry } from "./PA.UIM.Core/AppManagerRegistry";
import { PlatformSession } from "./PA.UIM.Core/PlatformSession";
import { PlatformViewport } from "./PA.UIM.Core/PlatformViewport";
import { ApplicationSession } from "./PA.UIM.Core/ApplicationSession";
import { ApplicationModuleSession } from "./PA.UIM.Core/ApplicationModuleSession";
import { SearchUtils } from "./PA.UIM.Core/SearchUtils";
import {
    HorizAlignment,
    SearchProviderFieldType,
    SelectModes,
    TreeRenderOptionsDefault,
} from "./PA.UIM.Core/PA.UIM.Core.IF.Search";
import { Search } from "./PA.UIM.Core/SearchDataSource";
import { UserSearch } from "./PA.UIM.Security/UserSearch";
import { AuthProviderSearch } from "./PA.UIM.Security/AuthProviderSearch";
import { UserGroupSearch } from "./PA.UIM.Security/UserGroupSearch";
import { UserGroupSearchByList } from "./PA.UIM.Security/UserGroupSearchByList";
import { UserGroupTypeSearch } from "./PA.UIM.Security/UserGroupTypeSearch";
import { UserGroupHierarchySearch } from "./PA.UIM.Security/UserGroupHierarchySearch";
import { UserGroupChildrenHierarchy } from "./PA.UIM.Security/UserGroupChildrenHierarchy";
import { MasterDataSetSearch } from "./PA.UIM.MD/MasterDataSetSearch";
import { AttributeTypeSearchByList } from "./PA.UIM.MD/AttributeTypeSearchByList";
import { DomainItemSearch } from "./PA.UIM.MD/DomainItemSearch";
import { DomainItemSearchByList } from "./PA.UIM.MD/DomainItemSearchByList";
import { CustomerSearch } from "./PA.UIM.MD/CustomerSearch";
import { CustomerManagerSearch } from "./PA.UIM.MD/CustomerManagerSearch";
import { CurrencySearch } from "./PA.UIM.MD/CurrencySearch";
import { CustomerProxySearch } from "./PA.UIM.MD/CustomerProxySearch";
import { CustomerExternalSearch } from "./PA.UIM.MD/CustomerExternalSearch";
import { CustomerPlanningSearch } from "./PA.UIM.MD/CustomerPlanningSearch";
import { CustomerModelSearch } from "./PA.UIM.MD/CustomerModelSearch";
import { CustomerSearchByList } from "./PA.UIM.MD/CustomerSearchByList";
import { CustomerTypeSearch } from "./PA.UIM.MD/CustomerTypeSearch";
import { SourceCustomerTypeSearch } from "./PA.UIM.MD/SourceCustomerTypeSearch";
import { CBOCustomerSearch } from "./PA.UIM.Simulation/CBOCustomerSearch";
import { ExchangeRateTypeSearch } from "./PA.UIM.MD/ExchangeRateTypeSearch";
import { SourceTypeSearch } from "./PA.UIM.MD/SourceTypeSearch";
import { SetSearch } from "./PA.UIM.MD/SetSearch";
import { ApprovalSearch } from "./PA.UIM.MD/ApprovalSearch";
import { AffinitySetSearch } from "./PA.UIM.MD/AffinitySetSearch";
import { AffinitySetSearchByCannibalizationType } from "./PA.UIM.MD/AffinitySetSearchByCannibalizationType";
import { AffinitySetSearchByList } from "./PA.UIM.MD/AffinitySetSearchByList";
import { SourceSearch } from "./PA.UIM.MD/SourceSearch";
import { TagSearch } from "./PA.UIM.MD/TagSearch";
import { TagSourceSearch } from "./PA.UIM.MD/TagSourceSearch";
import { TagFunctionSearch } from "./PA.UIM.MD/TagFunctionSearch";
import { TagRuleSearch } from "./PA.UIM.MD/TagRuleSearch";
import { DomainSearch } from "./PA.UIM.MD/DomainSearch";
import { ProductGroupSearch } from "./PA.UIM.MD/ProductGroupSearch";
import { ProductGroupSearchByList } from "./PA.UIM.MD/ProductGroupSearchByList";
import { ProductGroupSearchByCannibalizationType } from "./PA.UIM.MD/ProductGroupSearchByCannibalizationType";
import { ProductSearch } from "./PA.UIM.MD/ProductSearch";
import { ProductSearchByList } from "./PA.UIM.MD/ProductSearchByList";
import { ProductManagerSearch } from "./PA.UIM.MD/ProductManagerSearch";
import { ShipperProductsSearch } from "./PA.UIM.MD/ShipperProductsSearch";
import { ProductTypeSearch } from "./PA.UIM.MD/ProductTypeSearch";
import { PricingEngineSearch } from "./PA.UIM.MD/PricingEngineSearch";
import { PolicySearch } from "./PA.UIM.MD/PolicySearch";
import { PolicyAreaSearch } from "./PA.UIM.MD/PolicyAreaSearch";
import { PolicyCubeProcessSearch } from "./PA.UIM.MD/PolicyCubeProcessSearch";
import { MetaSearch } from "./PA.UIM.MD/MetaSearch";
import { JobSearch } from "./PA.UIM.MD/JobSearch";
import { NoteSearch } from "./PA.UIM.MD/NoteSearch";
import { SnapshotSearch } from "./PA.UIM.MD/SnapshotSearch";
import { SpendAllocationRuleSearch } from "./PA.UIM.MD/SpendAllocationRuleSearch";
import { GeneralLedgerSearch } from "./PA.UIM.MD/GeneralLedgerSearch";
import { GeneralLedgerAccountSearch } from "./PA.UIM.MD/GeneralLedgerAccountSearch";
import { GeneralLedgerPolicySearch } from "./PA.UIM.MD/GeneralLedgerPolicySearch";
import { FundTypeSearch } from "./PA.UIM.MD/FundTypeSearch";
import { TransactionSearch } from "./PA.UIM.MD/TransactionSearch";
import { TransactionTypeSearch } from "./PA.UIM.MD/TransactionTypeSearch";
import { WorkflowSearch } from "./PA.UIM.MD/WorkflowSearch";
import { WorkflowStatusSearchByList } from "./PA.UIM.MD/WorkflowStatusSearchByList";
import { BaseLnSearch } from "./PA.UIM.MD/BaseLnSearch";
import { BaselineSearch } from "./PA.UIM.MD/BaselineSearch";
import { PlanManagementSearch } from "./PA.UIM.MD/PlanManagementSearch";
import { PlannedShipments } from "./PA.UIM.MD/PlannedShipments";
import { EventTypeSearch } from "./PA.UIM.MD/EventTypeSearch";
import { PlanTypeSearch } from "./PA.UIM.MD/PlanTypeSearch";
import { PaymentTypeSearch } from "./PA.UIM.Settlements/PaymentTypeSearch";
import { PaymentSearch } from "./PA.UIM.Settlements/PaymentSearch";
import { EventSpendTypeSearch } from "./PA.UIM.MD/EventSpendTypeSearch";
import { CustomerWholeSalerSearch } from "./PA.UIM.MD/CustomerWholeSalerSearch";
import { PeriodSearch } from "./PA.UIM.MD/PeriodSearch";
import { ProductConditionTypeSearch } from "./PA.UIM.MD/ProductConditionTypeSearch";
import { ProductHierarchySearch } from "./PA.UIM.MD/ProductHierarchySearch";
import { CustomerHierarchySearch } from "./PA.UIM.MD/CustomerHierarchySearch";
import { MetricDefinitionSearch } from "./PA.UIM.MD/MetricDefinitionSearch";
import { MetricDefinitionSearchByList } from "./PA.UIM.MD/MetricDefinitionSearchByList";
import { CubeSourceMetricIdSearchByList } from "./PA.UIM.MD/CubeSourceMetricIdByList";
import { MetricViewSearch } from "./PA.UIM.MD/MetricViewSearch";
import { SnapshotTypeSearch } from "./PA.UIM.TPM/SnapshotTypeSearch";
import { EventAccrualSearchByList } from "./PA.UIM.MD/EventAccrualSearchByList";
import { SnapshotAccrualBrandSearchByList } from "./PA.UIM.MD/SnapshotAccrualBrandSearchByList";
import { JobProcessorSearch } from "./PA.UIM.MD/JobProcessorSearch";
import { BusinessUnitSearch } from "./PA.UIM.MD/BusinessUnitSearch";
import { SalesOrgSearch } from "./PA.UIM.MD/SalesOrgSearch";
import { SalesAreaSearch } from "./PA.UIM.MD/SalesAreaSearch";
import { ProductAttributeGroupSearch } from "./PA.UIM.MD/ProductAttributeGroupSearch";
import { ProductAttributeMapSearch } from "./PA.UIM.MD/ProductAttributeMapSearch";
import { PeriodHierarchySearch } from "./PA.UIM.MD/PeriodHierarchySearch";
import { PeriodTypeSearch } from "./PA.UIM.MD/PeriodTypeSearch";
import { CustomColumnSearch } from "./PA.UIM.MD/CustomColumnSearch";
import { PartitionSearch } from "./PA.UIM.MD/PartitionSearch";
import { ControlPointTypeSearch } from "./PA.UIM.MD/ControlPointTypeSearch";
import { ControlPointSearch } from "./PA.UIM.MD/ControlPointSearch";
import { LESpendSearch } from "./PA.UIM.MD/LESpendSearch";
import { ActSpendSearch } from "./PA.UIM.MD/ActSpendSearch";
import { ClassificationSearch } from "./PA.UIM.MD/ClassificationSearch";
import { ClassificationControlSearch } from "./PA.UIM.MD/ClassificationControlSearch";
import { UOMSearch } from "./PA.UIM.MD/UOMSearch";
import { DataObjectSearch } from "./PA.UIM.MD/DataObjectSearch";
import { CircularConfigSearch } from "./PA.UIM.MD/CircularConfigSearch";
import { CircularSearch } from "./PA.UIM.MD/CircularSearch";
import { CompanySearch } from "./PA.UIM.MD/CompanySearch";
import { TimeManagerSearch } from "./PA.UIM.MD/TimeManagerSearch";
import { PeriodCompanySearch } from "./PA.UIM.MD/PeriodCompanySearch";
import { SearchConfigSearch } from "./PA.UIM.MD/SearchConfigSearch";
import { SearchProfileSearch } from "./PA.UIM.MD/SearchProfileSearch";
import { HierarchySearch } from "./PA.UIM.MD/HierarchySearch";
import { HierarchyEditorSearch } from "./PA.UIM.MD/HierarchyEditorSearch";
import { ConsumptionAdjustmentCollectionContext } from "./PA.UIM.Consumption/ConsumptionAdjustmentCollectionContext";
import { EDLPAnalysisAxisList } from "./PA.UIM.Consumption/EDLPAnalysisGraphComponents";
import { CannibalizationSetSearch } from "./PA.UIM.Consumption/CannibalizationSetSearch";
import { CannibalizationSetGraphCalculator } from "./PA.UIM.Consumption/CannibalizationSetGraphCalculator";
import {
    CannibalizationSetAggressorAxisList,
    CannibalizationSetVictimAxisList,
} from "./PA.UIM.Consumption/CannibalizationSetGraphComponents";
import { PeriodMetricContext } from "./PA.UIM.Metric/PeriodMetricContext";
import { FullStandardAxisList } from "./PA.UIM.Metric/StandardGraphComponents";
import { PAMetricServiceClient } from "./PA.Metric.Services/PAMetricServiceClient";
import { EventCollectionContext } from "./PA.UIM.TPM/EventCollectionContext";
import { PlanSearch, PlanSearchNoLock } from "./PA.UIM.TPM/PlanSearch";
import { EventSearch } from "./PA.UIM.TPM/EventSearch";
import { TPMPlanSearch, TPMPlanSearchNoLock } from "./PA.UIM.TPM/TPMPlanSearch";
import { TPMEventSearch } from "./PA.UIM.TPM/TPMEventSearch";
import { PlanMetricViewProvider } from "./PA.UIM.TPM/PlanMetricsClientView";
import { PlanMetricFieldType } from "./PA.UIM.TPM/PA.UIM.TPM.IF";
import { TPMBulkApprovalSearch } from "./PA.UIM.TPM/TPMBulkApprovalSearch";
import { TPMBulkApprovalEventSearchByList } from "./PA.UIM.TPM/TPMBulkApprovalEventSearchByList";
import { TPMPlanSearchByCustomer } from "./PA.UIM.TPM/TPMPlanSearchByCustomer";
import { TPMEventSpendSearch } from "./PA.UIM.TPM/TPMEventSpendSearch";
import { ClaimTypeSearch } from "./PA.UIM.Settlements/ClaimTypeSearch";
import { ClaimSearch } from "./PA.UIM.Settlements/ClaimSearch";
import { WorkspaceSearch } from "./PA.UIM.Reporting/WorkspaceSearch";
import { ReportTileSearch } from "./PA.UIM.Reporting/ReportTileSearch";
import { ConnectionSearch } from "./PA.UIM.Reporting/ConnectionSearch";
import { DimensionSearch } from "./PA.UIM.Reporting/DimensionSearch";
import { MockDimensionSelector } from "./PA.UIM.Reporting/MockDimensionDataProvider";
import { SubjectAreaSearch } from "./PA.UIM.Reporting/SubjectAreaSearch";
import { ReportSearch } from "./PA.UIM.Reporting/ReportSearch";
import { WorkspaceReportContext } from "./PA.UIM.Reporting/ReportWorkspaceContext";
import { DimensionPlacement } from "./PA.Reporting.Core/PA.Reporting.IF";
import { EventPortfolioSearch } from "./PA.Reporting.BusinessObjects/EventPortfolioSearch";
import { CubeSourceSearch } from "./PA.UIM.Reporting/CubeSourceSearch";
import { LoaderSearch } from "./PA.UIM.Loader/LoaderSearch";
import { LoaderOperationSearch } from "./PA.UIM.Loader/LoaderOperationSearch";
import { LoaderSourceSearch } from "./PA.UIM.Loader/LoaderSourceSearch";
import { ModelPredictorSearch } from "./PA.UIM.Model/ModelPredictorSearch";
import { ModelCannibalizationTypeSearch } from "./PA.UIM.Model/ModelCannibalizationTypeSearch";
import { ModelFunctionSearch } from "./PA.UIM.Model/ModelFunctionSearch";
import { ModelingSessionSearch } from "./PA.UIM.Model/ModelingSessionSearch";
import { ModelSearch } from "./PA.UIM.Model/ModelSearch";
import { ModelVolumeComponentSearch } from "./PA.UIM.Model/ModelVolumeComponentSearch";
import { VolumeDecompModelVolumeSearch } from "./PA.UIM.Model/VolumeDecompModelVolumeSearch";
import { ModelCoefficientSearch } from "./PA.UIM.Model/ModelCoefficientSearch";
import { ModelCoefficientSetSearch } from "./PA.UIM.Model/ModelCoefficientSetSearch";
import { ModelInputSearch } from "./PA.UIM.Model/ModelInputSearch";
import { ModelingSessionGraphCalculator } from "./PA.UIM.Model/ModelingSessionGraphCalculator";
import { ModelingSessionAxisList } from "./PA.UIM.Model/ModelingSessionGraphComponents";
import { ModelingEngineMetricLevels } from "./PA.Model.Services/ModelingSessionServices.IF";
import { ModelTermSearch } from "./PA.UIM.Model/ModelTermSearch";
import { PublishedModelSearch } from "./PA.UIM.Model/PublishedModelSearch";
import { ModelDataSourceSearch } from "./PA.UIM.Model/ModelDataSourceSearch";
import { ModelPowerMetricSearch } from "./PA.UIM.Model/ModelPowerMetricSearch";
import { ModelingSessionRefValuesByList } from "./PA.UIM.Model/ModelingSessionRefValuesByList";
import { ModelingSessionRefValuesOverrideSearch } from "./PA.UIM.Model/ModelingSessionRefValuesOverrideSearch";
import { ModelConstantSearch } from "./PA.UIM.Model/ModelConstantSearch";
import { ModelCompareSearch } from "./PA.UIM.Model/ModelCompareSearch";
import { ModelCompareModelingSessionByList } from "./PA.UIM.Model/ModelCompareModelingSessionsByList";
import { SimulationInputSearch } from "./PA.UIM.Simulation/SimulationInputSearch";
import { SimulationComparisonSearch, SimulationSearch } from "./PA.UIM.Simulation/SimulationSearch";
import { ConstraintBasedOptimizerSearch } from "./PA.UIM.Simulation/ConstraintBasedOptimizerSearch";
import { SpendFunctionSearch } from "./PA.Simulation.BusinessObjects/SpendFunctionSearch";
import { UIProfileSearch } from "./PA.UIM.UIFramework/UIProfileSearch";
import { UIAppSuiteTypeSearch } from "./PA.UIM.UIFramework/UIAppSuiteTypeSearch";
import { UIApplicationSearch } from "./PA.UIM.UIFramework/UIApplicationSearch";
import { UIAppSuiteSearch } from "./PA.UIM.UIFramework/UIAppSuiteSearch";
import { UIAppModuleSearch } from "./PA.UIM.UIFramework/UIAppModuleSearch";
import { UIAppExecSearch } from "./PA.UIM.UIFramework/UIAppExecSearch";
import { SnapshotParameterSearch } from "./PA.UIM.MD/SnapshotParameterSearch";
import { DataSetPart, MapeRange } from "./PA.Model.Services/ModelingScorecardService.IF";
import { PeriodSearchByMDSet } from "./PA.UIM.Core/PeriodSearchByMDSet";
import { TermConditionEditorSearch } from "./PA.UIM.MD/TermConditionSearch";
import { BatchProcessSearch } from "./PA.UIM.MD/BatchProcessSearch";
import { BatchScopeSearch } from "./PA.UIM.MD/BatchProcessScopeSearch";
import { CustomerSearchByMDSet } from "./PA.UIM.MD/CustomerSearchByMDSet";
import { ProductSearchByMDSet } from "./PA.UIM.MD/ProductSearchByMDSet";
import { ProductGroupSearchByMDSet } from "./PA.UIM.MD/ProductGroupSearchByMDSet";
import { SnapshotSearchWithType } from "./PA.UIM.MD/SnapshotSearchWithType";
import { DimensionSelector } from "./PA.Reporting.Core/DimensionSelector";
import { EventVolumeSearch } from "./PA.UIM.MD/EventVolumeSearch";
import { DataMartSearch } from "./PA.UIM.MD/DataMartSearch";
import { SearchObjectTreeDataManager } from "./PA.UIM.Core/SearchObjectTreeDataManager";
import { ScenarioPlanSearch } from "./PA.UIM.Simulation/ScenarioPlanSearch";
import { ModelProfileGroupPredictorSearchByList } from "./PA.UIM.Model/ModelProfileGroupPredictorSearch";
import { VolDecompSearch } from "./PA.UIM.MD/VolDecompSearch";
import { PPAModelSearch } from "./PA.UIM.PPA/PPAModelSearch"
import { ScenarioPlannerSearch } from "./PA.UIM.Simulation/ScenarioPlannerSearch";
import { EventTacticSearch } from './PA.UIM.TPM/EventTacticSearch'
import { ScenarioConstraintSearch } from "./PA.UIM.Simulation/ScenarioConstraintSearch";


const MdlUI = {
    UI: {
        ApplicationManagerRegistry: ApplicationManagerRegistry,
        PlatformSession: PlatformSession,
        PlatformViewport: PlatformViewport,
        ApplicationSession: ApplicationSession,
        ApplicationModuleSession: ApplicationModuleSession,

        Search: {
            SearchUtils: SearchUtils,
            SelectModes: SelectModes,
            SearchProviderFieldType: SearchProviderFieldType,
            HorizAlignment: HorizAlignment,
            TreeRenderOptionsDefault: TreeRenderOptionsDefault,
            Search: Search,
            SearchObjectTreeDataManager: SearchObjectTreeDataManager,
        },

        Security: {
            UserSearch: UserSearch,
            AuthProviderSearch: AuthProviderSearch,
            UserGroupSearch: UserGroupSearch,
            UserGroupSearchByList: UserGroupSearchByList,
            UserGroupTypeSearch: UserGroupTypeSearch,
            UserGroupHierarchySearch: UserGroupHierarchySearch,
            UserGroupChildrenHierarchy: UserGroupChildrenHierarchy,
        },

        MD: {
            MasterDataSetSearch: MasterDataSetSearch,
            AttributeTypeSearchByList: AttributeTypeSearchByList,
            DomainItemSearch: DomainItemSearch,
            DomainItemSearchByList: DomainItemSearchByList,
            CustomerSearch: CustomerSearch,
            CustomerSearchByMDSet: CustomerSearchByMDSet,
            CustomerManagerSearch: CustomerManagerSearch,
            CurrencySearch: CurrencySearch,
            CustomerProxySearch: CustomerProxySearch,
            CustomerExternalSearch: CustomerExternalSearch,
            CustomerPlanningSearch: CustomerPlanningSearch,
            CustomerModelSearch: CustomerModelSearch,
            CustomerSearchByList: CustomerSearchByList,
            CustomerTypeSearch: CustomerTypeSearch,
            SourceCustomerTypeSearch: SourceCustomerTypeSearch,
            CBOCustomerSearch: CBOCustomerSearch,
            ExchangeRateTypeSearch: ExchangeRateTypeSearch,
            SourceTypeSearch: SourceTypeSearch,
            SetSearch: SetSearch,
            ApprovalSearch: ApprovalSearch,
            AffinitySetSearch: AffinitySetSearch,
            AffinitySetSearchByCannibalizationType: AffinitySetSearchByCannibalizationType,
            AffinitySetSearchByList: AffinitySetSearchByList,
            SourceSearch: SourceSearch,
            TagSearch: TagSearch,
            TagSourceSearch: TagSourceSearch,
            TagFunctionSearch: TagFunctionSearch,
            TagRuleSearch: TagRuleSearch,
            DomainSearch: DomainSearch,
            ProductGroupSearch: ProductGroupSearch,
            ProductGroupSearchByMDSet: ProductGroupSearchByMDSet,
            ProductGroupSearchByList: ProductGroupSearchByList,
            ProductGroupSearchByCannibalizationType: ProductGroupSearchByCannibalizationType,
            ProductSearch: ProductSearch,
            ProductSearchByMDSet: ProductSearchByMDSet,
            ProductSearchByList: ProductSearchByList,
            ProductManagerSearch: ProductManagerSearch,
            ShipperProductsSearch: ShipperProductsSearch,
            ProductTypeSearch: ProductTypeSearch,
            BatchScopeSearch: BatchScopeSearch,
            PricingEngineSearch: PricingEngineSearch,
            PolicySearch: PolicySearch,
            PolicyAreaSearch: PolicyAreaSearch,
            PolicyCubeProcessSearch: PolicyCubeProcessSearch,
            MetaSearch: MetaSearch,
            JobSearch: JobSearch,
            FinishedProduct: ProductSearch,
            NoteSearch: NoteSearch,
            SnapshotSearch: SnapshotSearch,
            SnapshotSearchWithType: SnapshotSearchWithType,
            SnapshotParameterSearch: SnapshotParameterSearch,
            SpendAllocationRuleSearch: SpendAllocationRuleSearch,
            GeneralLedgerSearch: GeneralLedgerSearch,
            GeneralLedgerAccountSearch: GeneralLedgerAccountSearch,
            GeneralLedgerPolicySearch: GeneralLedgerPolicySearch,
            FundTypeSearch: FundTypeSearch,
            TransactionSearch: TransactionSearch,
            TransactionTypeSearch: TransactionTypeSearch,
            WorkflowSearch: WorkflowSearch,
            WorkflowStatusSearchByList: WorkflowStatusSearchByList,
            BaseLnSearch: BaseLnSearch,
            BaselineSearch: BaselineSearch,
            PlanManagementSearch: PlanManagementSearch,
            PlannedShipments: PlannedShipments,
            EventTypeSearch: EventTypeSearch,
            PlanTypeSearch: PlanTypeSearch,
            PaymentTypeSearch: PaymentTypeSearch,
            PaymentSearch: PaymentSearch,
            EventSpendTypeSearch: EventSpendTypeSearch,
            CustomerWholeSalerSearch: CustomerWholeSalerSearch,
            PeriodSearch: PeriodSearch,
            PeriodSearchByMDSet: PeriodSearchByMDSet,
            ProductConditionTypeSearch: ProductConditionTypeSearch,
            ProductHierarchySearch: ProductHierarchySearch,
            CustomerHierarchySearch: CustomerHierarchySearch,
            MetricDefinitionSearch: MetricDefinitionSearch,
            MetricDefinitionSearchByList: MetricDefinitionSearchByList,
            CubeSourceMetricIdSearchByList: CubeSourceMetricIdSearchByList,
            MetricViewSearch: MetricViewSearch,
            SnapshotTypeSearch: SnapshotTypeSearch,
            EventAccrualSearchByList: EventAccrualSearchByList,
            SnapshotAccrualBrandSearchByList: SnapshotAccrualBrandSearchByList,
            JobProcessorSearch: JobProcessorSearch,
            BusinessUnitSearch: BusinessUnitSearch,
            SalesOrgSearch: SalesOrgSearch,
            SalesAreaSearch: SalesAreaSearch,
            ProductAttributeGroupSearch: ProductAttributeGroupSearch,
            ProductAttributeMapSearch: ProductAttributeMapSearch,
            PeriodHierarchySearch: PeriodHierarchySearch,
            PeriodTypeSearch: PeriodTypeSearch,
            CustomColumnSearch: CustomColumnSearch,
            PartitionSearch: PartitionSearch,
            ControlPointTypeSearch: ControlPointTypeSearch,
            ControlPointSearch: ControlPointSearch,
            BatchProcessSearch: BatchProcessSearch,
            LESpendSearch: LESpendSearch,
            ActSpendSearch: ActSpendSearch,
            ClassificationSearch: ClassificationSearch,
            ClassificationControlSearch: ClassificationControlSearch,
            BenchmarkSearch: BusinessUnitSearch,
            UOMSearch: UOMSearch,
            DataObjectSearch: DataObjectSearch,
            CircularConfigSearch: CircularConfigSearch,
            CircularSearch: CircularSearch,
            CompanySearch: CompanySearch,
            TimeManagerSearch: TimeManagerSearch,
            PeriodCompanySearch: PeriodCompanySearch,
            SearchConfigSearch: SearchConfigSearch,
            SearchProfileSearch: SearchProfileSearch,
            HierarchySearch: HierarchySearch,
            HierarchyEditorSearch: HierarchyEditorSearch,
            TermConditionEditorSearch: TermConditionEditorSearch,
            DataMartSearch: DataMartSearch,
            EventVolumeSearch: EventVolumeSearch,
            VolDecompSearch: VolDecompSearch,
        },
        Consumption: {
            ConsumptionAdjustmentCollectionContext: ConsumptionAdjustmentCollectionContext,
            EDLPAnalysisAxisList: EDLPAnalysisAxisList,
            CannibalizationSetSearch: CannibalizationSetSearch,
            CannibalizationSetGraphCalculator: CannibalizationSetGraphCalculator,
            CannibalizationSetAggressorAxisList: CannibalizationSetAggressorAxisList,
            CannibalizationSetVictimAxisList: CannibalizationSetVictimAxisList,
        },
        Metrics: {
            PeriodMetricContext: PeriodMetricContext,
            StandardAxisList: FullStandardAxisList,
            PAMetricServiceClient: PAMetricServiceClient,
        },
        TPM: {
            EventCollectionContext: EventCollectionContext,
            PlanSearch: PlanSearch,
            EventSearch: EventSearch,
            EventTacticSearch:EventTacticSearch,
            TPMPlanSearch: TPMPlanSearch,
            TPMEventSearch: TPMEventSearch,
            PlanMetricViewProvider: PlanMetricViewProvider,
            PlanMetricFieldType: PlanMetricFieldType,
            TPMBulkApprovalSearch: TPMBulkApprovalSearch,
            TPMBulkApprovalEventSearchByList: TPMBulkApprovalEventSearchByList,
            TPMPlanSearchByCustomer: TPMPlanSearchByCustomer,
            TPMEventSpendSearch: TPMEventSpendSearch,
            PlanSearchNoLock: PlanSearchNoLock,
        },
        Settlements: {
            ClaimTypeSearch: ClaimTypeSearch,
            ClaimSearch: ClaimSearch,
        },
        Reporting: {
            WorkspaceSearch: WorkspaceSearch,
            ReportTileSearch: ReportTileSearch,
            ConnectionSearch: ConnectionSearch,
            DimensionSearch: DimensionSearch,
            MockDimensionSelector: MockDimensionSelector,
            DimensionSelector: DimensionSelector,
            SubjectAreaSearch: SubjectAreaSearch,
            ReportSearch: ReportSearch,
            WorkspaceReportContext: WorkspaceReportContext,
            DimensionPlacement: DimensionPlacement,
            EventPortfolioSearch: EventPortfolioSearch,
            CubeSourceSearch: CubeSourceSearch,
        },
        User: {},
        Loader: {
            LoaderSearch: LoaderSearch,
            LoaderOperationSearch: LoaderOperationSearch,
            LoaderSourceSearch: LoaderSourceSearch,
        },
        Model: {
            ModelPredictorSearch: ModelPredictorSearch,
            ModelCannibalizationTypeSearch: ModelCannibalizationTypeSearch,
            ModelFunctionSearch: ModelFunctionSearch,
            ModelingSessionSearch: ModelingSessionSearch,
            ModelSearch: ModelSearch,
            ModelVolumeComponentSearch: ModelVolumeComponentSearch,
            VolumeDecompModelVolumeSearch: VolumeDecompModelVolumeSearch,
            ModelCoefficientSearch: ModelCoefficientSearch,
            ModelCoefficientSetSearch: ModelCoefficientSetSearch,
            ModelInputSearch: ModelInputSearch,
            ModelingSessionGraphCalculator: ModelingSessionGraphCalculator,
            ModelingSessionAxisList: ModelingSessionAxisList,
            ModelingEngineMetricLevels: ModelingEngineMetricLevels,
            ModelTermSearch: ModelTermSearch,
            PublishedModelSearch: PublishedModelSearch,
            ModelDataSourceSearch: ModelDataSourceSearch,
            ModelPowerMetricSearch: ModelPowerMetricSearch,
            ModelingSessionRefValuesByList: ModelingSessionRefValuesByList,
            ModelingSessionRefValuesOverrideSearch: ModelingSessionRefValuesOverrideSearch,
            ModelConstantSearch: ModelConstantSearch,
            ModelCompareSearch: ModelCompareSearch,
            ModelCompareModelingSessionsByList: ModelCompareModelingSessionByList,
            DataSetPart: DataSetPart,
            MapeRange: MapeRange,
            ModelProfileGroupPredictorSearchByList: ModelProfileGroupPredictorSearchByList,
        },
        Simulation: {
            ScenarioPlanSearch: ScenarioPlanSearch,
            SimulationInputSearch: SimulationInputSearch,
            SimulationSearch: SimulationSearch,
            SimulationComparisonSearch: SimulationComparisonSearch,
            ScenarioPlannerSearch: ScenarioPlannerSearch,
            ScenarioConstraintSearch: ScenarioConstraintSearch,
            ConstraintBasedOptimizerSearch: ConstraintBasedOptimizerSearch,
            SpendFunctionSearch: SpendFunctionSearch,
        },
        UIFramework: {
            UIProfileSearch: UIProfileSearch,
            UIAppSuiteTypeSearch: UIAppSuiteTypeSearch,
            UIApplicationSearch: UIApplicationSearch,
            UIAppSuiteSearch: UIAppSuiteSearch,
            UIAppModuleSearch: UIAppModuleSearch,
            UIAppExecSearch: UIAppExecSearch,
        },
        PPA:{
            PPAModelSearch: PPAModelSearch
        }
    },
};

export { MdlUI };
